// extracted by mini-css-extract-plugin
export default {"MaterialEmpty":"MaterialEmpty_MaterialEmpty__ga64q","emptyImg":"MaterialEmpty_emptyImg__RLZ1E","text":"MaterialEmpty_text__PNeGa","uploadBtn":"MaterialEmpty_uploadBtn__XHIZa"};